import axios from 'axios'
import store from '@/store'

let STATUS_CODE = {
  SUCCESS: 0,
  FAIL: 1,
}

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 10000, // 请求超时时间
})

const err = (error) => {
  if (error.response) {
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use((config) => {
  // const token = Vue.ls.get(ACCESS_TOKEN)
  // if (token) {
  //   config.headers['Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  // }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  let R = response.data
  console.log('on R', R)
  let code = R.code
  switch (code) {
    case STATUS_CODE.SUCCESS: {
      console.log('biz success, msg:', R.msg)
      return R.data
    }
    case STATUS_CODE.FAIL: {
      console.log('biz fail, msg: ', R.msg)
    }
  }
  return response
}, err)

export { service as axios }
